import { ENV } from 'src/env';
import { Entity } from 'webpanel-admin';
import { SortInfoOrder } from 'webpanel-data';
import { api } from './api';
import { author } from './author';
import { documentCategory } from './document-category';

export const document = new Entity({
  name: 'Document',
  title: 'Dokumenty',
  icon: 'file-pdf',
  dataSource: api,
  searchable: true,
  edit: {
    initialValues: { date: new Date() }
  },
  list: {
    initialSorting: [{ columnKey: 'date', order: SortInfoOrder.descend }]
  }
})
  .inputField('name', {
    title: 'Název',
    sortable: true,
    filter: true
  })
  .relationshipField('category', {
    title: 'Kategorie',
    type: 'toOne',
    targetEntity: () => documentCategory
  })
  .dateField('date', { title: 'Datum', sortable: true })
  .fileField('file', {
    title: 'Soubor',
    uploadURL: `${ENV.REACT_APP_FILE_UPLOAD_URL}`
  })
  .relationshipField('author', {
    title: 'Autor',
    type: 'toOne',
    targetEntity: () => author
  });



// WEBPACK FOOTER //
// ./src/model/document.tsx